import { SETTINGS as company } from "views/Configuration/settings/company";
import { SETTINGS as connections } from "views/Configuration/settings/connections";
import { SETTINGS as fulfillment } from "views/Configuration/settings/fulfillment";
import { SETTINGS as inventory } from "views/Configuration/settings/inventory";
import { SETTINGS as payments } from "views/Configuration/settings/payments";
import { SETTINGS as production } from "views/Configuration/settings/production";
import { SETTINGS as purchasing } from "views/Configuration/settings/purchasing";
import { SETTINGS as rentals } from "views/Configuration/settings/rentals";
import { SETTINGS as sales } from "views/Configuration/settings/sales";

export const SETTINGS = {
  company,
  inventory,
  purchasing,
  production,
  fulfillment,
  rentals,
  sales,
  payments,
  connections,
};
